import React, { useState, useContext, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import { AuthContext } from "../AuthContext";
import Select from "react-select";

export default function WorkerAdvanceForm() {
  const { user } = useContext(AuthContext);

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const [workerList, setWorkerList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [form, setForm] = useState({
    WORKER_CODE: "",
    WORKER_NAME: "",
    LOGIC_ACCOUNT_CODE: "",
    LOGIC_ACCOUNT_NAME: "",
    BANK_ACCOUNT_NO: "",
    IFSC_CODE: "",
    Gender: "",
    Department: "",
    Amount: "",
    Reason: "",
    SubmittedBy: ""
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      const res = await axiosInstance.get("/api/worker-advance/staff");
      setStaffList(res.data);
    } catch (err) {
      console.error("Error loading staff:", err);
    }
  };

  /* ================= FETCH ================= */
  const searchWorker = async (text) => {
    setSearchTerm(text);
    if (!text) return setWorkerList([]);

    try {
      const res = await axiosInstance.get('/api/worker-advance/search', { params: { q: text } });
      setWorkerList(res.data);
    } catch (err) {
      console.error("Worker search error:", err);
    }
  };

  /* ================= VALIDATION ================= */
  const validateForm = () => {
    let newErrors = {};

    if (!form.WORKER_CODE) newErrors.WORKER_CODE = "Worker selection is required";
    if (!form.Amount || form.Amount <= 0) newErrors.Amount = "Valid amount is required";
    if (!form.Reason) newErrors.Reason = "Reason is required";
    if (!form.SubmittedBy) newErrors.SubmittedBy = "Submitted By Email is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const payload = {
        ...form
      };

      await axiosInstance.post("/api/worker-advance/submit", payload);

      // RESET
      setForm({
        WORKER_CODE: "",
        WORKER_NAME: "",
        LOGIC_ACCOUNT_CODE: "",
        LOGIC_ACCOUNT_NAME: "",
        BANK_ACCOUNT_NO: "",
        IFSC_CODE: "",
        Gender: "",
        Department: "",
        Amount: "",
        Reason: "",
        SubmittedBy: ""
      });
      setSearchTerm("");
      setErrors({});
      setWorkerList([]);

      alert("Worker Advance request submitted successfully.");

    } catch (err) {
      console.error(err);
      alert("Error submitting request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex dashboard">
      {/* SIDEBAR */}
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        {/* HEADER */}
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />

        <main className="main-container p-4">
          <h3 className="mb-4">Worker Advance Form</h3>

          <div className="card shadow border-0">
            <div className="card-header bg-dark text-white">
              Worker Advance Form
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  
                  {/* Search bar */}
                  <div className="col-md-12 mb-3 position-relative">
                    <label>Search Worker Code / Logic Account Code / Name</label>
                    <input
                      className={`form-control ${errors.WORKER_CODE && "is-invalid"}`}
                      value={searchTerm}
                      onChange={(e) => searchWorker(e.target.value)}
                      placeholder="Type to search..."
                    />
                    {errors.WORKER_CODE && <div className="text-danger small">{errors.WORKER_CODE}</div>}

                    {workerList.length > 0 && (
                      <div className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                        {workerList.map((w, i) => (
                          <button
                            key={i}
                            type="button"
                            className="list-group-item list-group-item-action"
                            onClick={() => {
                              setForm({
                                ...form,
                                WORKER_CODE: w.WORKER_CODE || "",
                                WORKER_NAME: w.WORKER_NAME || "",
                                LOGIC_ACCOUNT_CODE: w.LOGIC_ACCOUNT_CODE || "",
                                LOGIC_ACCOUNT_NAME: w.LOGIC_ACCOUNT_NAME || "",
                                BANK_ACCOUNT_NO: w.BANK_ACCOUNT_NO || "",
                                IFSC_CODE: w.IFSC_CODE || "",
                                Gender: w.Gender || "",
                                Department: w.Department || ""
                              });
                              setSearchTerm(`${w.WORKER_CODE} - ${w.WORKER_NAME}`);
                              setWorkerList([]);
                            }}
                          >
                            {w.WORKER_CODE} - {w.WORKER_NAME} ({w.LOGIC_ACCOUNT_CODE})
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Worker Details (Read-only) */}
                  <div className="col-md-3 mb-3">
                    <label>Worker Code</label>
                    <input className="form-control bg-light" value={form.WORKER_CODE} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>Worker Name</label>
                    <input className="form-control bg-light" value={form.WORKER_NAME} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>Logic Account Code</label>
                    <input className="form-control bg-light" value={form.LOGIC_ACCOUNT_CODE} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>Logic Account Name</label>
                    <input className="form-control bg-light" value={form.LOGIC_ACCOUNT_NAME} readOnly />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label>Bank Account No</label>
                    <input className="form-control bg-light" value={form.BANK_ACCOUNT_NO} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>IFSC Code</label>
                    <input className="form-control bg-light" value={form.IFSC_CODE} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>Gender</label>
                    <input className="form-control bg-light" value={form.Gender} readOnly />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label>Department</label>
                    <input className="form-control bg-light" value={form.Department} readOnly />
                  </div>

                  {/* Amount Input */}
                  <div className="col-md-4 mb-3">
                    <label>Amount (in digits)</label>
                    <input
                      type="number"
                      className={`form-control ${errors.Amount && "is-invalid"}`}
                      value={form.Amount}
                      onChange={(e) => setForm({ ...form, Amount: e.target.value })}
                    />
                    {errors.Amount && <div className="text-danger small">{errors.Amount}</div>}
                  </div>

                  {/* Reason Input */}
                  <div className="col-md-4 mb-3">
                    <label>Reason</label>
                    <input
                      type="text"
                      className={`form-control ${errors.Reason && "is-invalid"}`}
                      value={form.Reason}
                      onChange={(e) => setForm({ ...form, Reason: e.target.value })}
                    />
                    {errors.Reason && <div className="text-danger small">{errors.Reason}</div>}
                  </div>

                  {/* Submitted By Input */}
                  <div className="col-md-4 mb-3">
                    <label>Submitted By (Email)</label>
                    <input
                      type="email"
                      className={`form-control ${errors.SubmittedBy && "is-invalid"}`}
                      value={form.SubmittedBy}
                      onChange={(e) => setForm({ ...form, SubmittedBy: e.target.value })}
                      placeholder="Enter Email..."
                    />
                    {errors.SubmittedBy && <div className="text-danger small">{errors.SubmittedBy}</div>}

                    {/*
                    <Select
                      options={staffList.map((staff) => ({
                        value: staff.email,
                        label: `${staff.employee_name} (${staff.email})`
                      }))}
                      onChange={(selectedOption) => setForm({ ...form, SubmittedBy: selectedOption ? selectedOption.value : "" })}
                      value={
                        form.SubmittedBy 
                          ? { 
                              value: form.SubmittedBy, 
                              label: staffList.find(s => s.email === form.SubmittedBy) 
                                ? `${staffList.find(s => s.email === form.SubmittedBy).employee_name} (${form.SubmittedBy})` 
                                : form.SubmittedBy 
                            } 
                          : null
                      }
                      isClearable
                      placeholder="Search Email..."
                    />
                    */}
                  </div>

                </div>

                <div className="text-end mt-3">
                  <button disabled={loading} className="btn btn-success">
                    {loading ? "Submitting..." : "Submit Advance Request"}
                  </button>
                </div>

              </form>
            </div>
          </div>

        </main>
      </div>
    </div>
  );
}
